
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";


export function getModifiers(registrationID, from, size, option, searchText) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/catalog/modifier`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            from,
            size,
            option,
            searchText,
          },
        }
      );

      return {
        totalItemscount: response.data.totalItemscount,
        searchResult: response.data.modifiers,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getActiveModifiers(registrationID) {
  return async (dispatch, getState) => {
    // let searchParameters = {
    //     "from": 0,
    //     "size": 10000,
    //     "track_total_hits": true,
    //     "query": {
    //         "bool": {
    //             "must": [
    //                 { "match": { "RegistrationID": registrationID } },
    //                 { "match": { "IsDeleted": "false" } }
    //             ]
    //         }
    //     },
    //     "sort": [
    //         {
    //           "ModifierGroup.keyword": {
    //             "order": "desc"
    //           }
    //         },
    //         {
    //           "ModifierName.keyword": {
    //             "order": "desc"
    //           }
    //         }
    //       ]
    // }
    // let addMessage = firebase.functions().httpsCallable('getModifiers');
    // return addMessage({ text: searchParameters }).then(function (result) {
    //     const modifiers = []
    //     let sanitizedMessage = result.data.text;
    //     sanitizedMessage.hits.hits.map((data, index) => {
    //         modifiers.push({ key: data._id, ...data._source })
    //     })
    //     dispatch({ type: actionTypes.MODIFIERS_GET, modifiers })
    // });
    //9 Mar 26
    const token = getState().user.uat;
    const response = await axios.get(constants.API_URL + "/catalog/modifier", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.data && response.data.modifiers) {
      let modifiers = response.data.modifiers;
      console.log("modifiers", modifiers);
      dispatch({ type: actionTypes.MODIFIERS_GET, modifiers });
    }
  };
}

export function saveModifiers(modifier, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/catalog/modifier/${key}`,
          modifier,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/catalog/modifier`,
          modifier,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteModifiers(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/modifier/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    

      if(response.data.code=="0"){
        return true
      }else{
        return false
      }
   

    } catch (error) {
      console.error("Error deleting:", error);
      throw error;
    }
  };
}



export function getModifierGroups(registrationID)  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/catalog/modifiergroup`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.modifierGroup;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function saveModifierGroup(modifierGroup, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/catalog/modifiergroup/${key}`,
          modifierGroup,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/catalog/modifiergroup`,
          modifierGroup,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function deleteModifierGroup(key)  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/modifiergroup/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    

      if(response.data.code=="0"){
        return true
      }else{
        return false
      }
   

    } catch (error) {
      console.error("Error deleting:", error);
      throw error;
    }
  };
}
